import { recordingTitleInvalidCheck } from '@App/helpers/work-entities/fields-validators'
import { stringEscapeNewlines } from '@App/helpers/string-escape-newlines'
import React from 'react'
import { Recording } from '@Entities/matching/recording-group-details'
import { RecordingModel } from '@Entities/work/recording-model'

interface RecordingCardHeaderProps {
    title: string | undefined
    data?: RecordingModel | Recording | null
    editFunction?(editingRecording?: RecordingModel | Recording | null): void
    removeFunction?(removeRecording?: RecordingModel | Recording | null): void
}
const RecordingCardHeader = (props: RecordingCardHeaderProps) => {
    const { title, data, editFunction, removeFunction } = props
    return (
        <div className="head">
            <p className={`bold ${recordingTitleInvalidCheck(title) ? 'red-text' : ''}`}>
                {title ? stringEscapeNewlines(title) : ''}
            </p>
            <div className="controls">
                {editFunction && (
                    <span className="small-2 medium" onClick={() => editFunction(data)}>
                        Edit
                    </span>
                )}
                {removeFunction && (
                    <span className="small-2 medium" onClick={() => removeFunction(data)}>
                        Remove
                    </span>
                )}
            </div>
        </div>
    )
}

export default RecordingCardHeader
